export default "__VITE_ASSET__B56lzpoN__"